module.exports = __webpack_public_path__ + "static/media/vacation-request.b2752969.svg";